export default __webpack_public_path__ + "pptx_16x1.png";